import { Quill } from 'react-quill';

import { FONTS, DEFAULT_FONT_INDEX } from 'components/Shared/Forms/RichTextEditor/RichTextEditorConstants';

// Defined in themes/base.js in quilljs
export const fillFontSelect = (select) => {
    FONTS.forEach((font, i) => {
        const option = document.createElement('option');
        if (i === DEFAULT_FONT_INDEX) {
            option.setAttribute('selected', 'selected');
        }
        option.setAttribute('value', `font-${i}`);
        option.innerHTML = font.name;
        option.style.fontFamily = font.fontFamily;
        select.appendChild(option);
    });
};

// Return the font for the given option value
const getFontIndex = (value) => {
    let index = parseInt(value.replace(/^font-/, ''), 10);
    if (isNaN(index)) {
        index = DEFAULT_FONT_INDEX;
    }
    return index;
};

const Picker = Quill.import('ui/picker');

export default class SnazzyFontPicker extends Picker {
    buildItem(option) {
        const item = super.buildItem(option);
        if (item && option && option.style.fontFamily) {
            item.style.fontFamily = option.style.fontFamily;
        }
        item.title = option.innerHTML;
        return item;
    }

    buildOptions(select) {
        super.buildOptions(select);
        const items = this.container.querySelector('.ql-picker-options').children;
        for (let i = 0; i < items.length; i++) {
            const option = this.select.options[i];
            if (option && option.selected) {
                this.selectItem(items[i]);
            }
        }
    }

    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        if (this.select.selectedIndex > -1) {
            const option = this.select.options[this.select.selectedIndex];
            if (option && option.style.fontFamily) {
                this.label.style.fontFamily = option.style.fontFamily;
            }
        }
    }
}

// It appears that React-Quill override the default font class attributor
// with a style attributor. This caused issues with fonts that had spaces
// in their names.
// The generated HTML for the info window will contain the data attribute
// We might want to parse it out before generating the iframe.
const Parchment = Quill.import('parchment');
class FontStyleAttributor extends Parchment.Attributor.Style {
    add(node, value) {
        if (!this.canAdd(node, value)) return false;
        const index = getFontIndex(value);
        node.style.fontFamily = FONTS[index].fontFamily;
        node.dataset.fontIndex = index;
        return true;
    }

    value(node) {
        const index = node.dataset.fontIndex || DEFAULT_FONT_INDEX;
        return `font-${index}`;
    }
}

// No need for a white list
const FontStyle = new FontStyleAttributor('font', 'font-family', {
    scope: Parchment.Scope.INLINE,
});
Quill.register(FontStyle, true);
